module.exports = __webpack_public_path__ + "img/M1.24b494a7.jpg";